import { Helmet } from "react-helmet";
import SelectPackage from "../components/AiHomePage/SelectPackage";
import BannerSection from "../components/YouTubeThumbnailHome/BannerSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import TestimonialSection from "../components/YouTubeThumbnailHome/TestimonialSection";
import FeatureTwo from "../components/YouTubeThumbnailHome/FeatureTwo";
import FaqsSection from "../components/YouTubeThumbnailHome/FaqsSection";
import ServiceSection from "../components/YouTubeThumbnailHome/ServiceSection";
import AllToolsList from "../components/Shared/AllToolsList/AllToolsList";

const Home = () => {
  return (
    <div id="smooth-wrapper">
      <Helmet>
        <title>Boost your Productivity with AI-powered Tools</title>
        <meta
          name="description"
          content="Create compelling, SEO-optimized product descriptions, titles, and bullet points in seconds with our AI-powered product detail generator for e-commerce stores."
        />
        <meta
          name="keywords"
          content="AI product description generator, e-commerce product detail generator, SEO product titles, AI bullet points, AI content for online stores"
        />
      </Helmet>

      <div id="smooth-content">
        <BannerSection />
        <FeaturesSection />
        <AboutSection />
        <FeatureTwo />
        <SelectPackage />
        <TestimonialSection />
      </div>
    </div>
  );
};

export default Home;
